var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Phone",
    clipPath: "url(#clip0_489_4040)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.72 16.48C21.12 16.48 19.52 16.16 18.08 15.68C17.6 15.52 17.12 15.68 16.8 16L14.72 18.56C10.72 16.96 7.2 13.44 5.28 9.6L7.84 7.36C8.16 7.04 8.32 6.4 8.16 6.08C7.84 4.48 7.52 2.88 7.52 1.28C7.52 0.48 6.88 0 6.24 0H1.6C0.8 0 0 0.32 0 1.28C0 13.6 10.24 24 22.72 24C23.68 24 24 23.2 24 22.4V17.76C24 17.12 23.36 16.48 22.72 16.48Z",
    fill: "#121010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_489_4040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.fc86e005dba038d68c8dfa3fd36fe814.svg";
export { ForwardRef as ReactComponent };